import React, { Fragment, useEffect, useState } from 'react';
import HeroSection from '../../Components/Main/Common/HeroSection';
import ContentRow from '../../Components/Main/Common/ContentRow';
import '../../CSS/main.scss';
import '../../CSS/about.scss';
import ChiranTonmoy from '../../Images/chiran_tonmoy.jpeg';
import AboutContent from '../../Components/Main/About/AboutContent';
import {ArrowRight} from 'react-feather';
import { Link } from 'react-router-dom';
import { fetchData } from '../../Utility/GlobalService';
import getUrl from '../../Utility/GetUrl';
// import GoBack from '../../Components/Main/Common/GoBack';
import {Dots} from 'react-preloaders2';

const About = ()=> {
const [loading,setLoading] = useState(true);
const [aboutData,setAboutData] = useState();
const [lifeHashTag,setLifeHashTag] = useState();
const [technologyData,setTechnologyData] = useState();
const [toolListData,setToolsData] = useState();
const [aboutMeData,setAboutMeData] = useState();
useEffect(()=>{
   getAboutData();
   getLifeHashTag();
   getTechnologyData();
   getToolListData();
   getAboutMeData();
   setLoading(false);
},[]);
const getAboutData = async()=>{
  const response = await fetchData(`${getUrl()}/about`);
  setAboutData(response);
}
const getLifeHashTag = async()=>{
  const response = await fetchData(`${getUrl()}/hastag`);
  setLifeHashTag(response);
}
const getTechnologyData = async()=>{
  const response = await fetchData(`${getUrl()}/technology`);
  setTechnologyData(response);
}
const getToolListData = async()=>{
  const response = await fetchData(`${getUrl()}/tool`);
  setToolsData(response);
}
const getAboutMeData = async()=>{
  const response = await fetchData(`${getUrl()}/aboutme`);
  setAboutMeData(response);
}
const objectData = [
{
title: "Hi I’M TONMOY CHIRAN",
content: `A progressive and simple person who
always tries to put a smile on face and
curious to learn new things. As for me
smile can heal a lot of things including
pressure as wel as your smile can also
be helpful for the one watching you smile,
as that person might find some motivation
from your smile.`,
image: `${ChiranTonmoy}`
}
];
const heroSectionContent = {
title: "EAT, SLEEP, LEARN,EXPLORE",
content: `LIFE OF TONMOY CHIRAN`
}

const lifeHastagData = [
  {
    title: "MY LIFE IN HASHTAGS",
    contents: [
      "Learning New Technology","videos Games","Clamness",
      "Exploring New Technology","Tech Books",
      "Exploring New Programming Language","Tech Articles",
      "Exploring New Tools","Adventure"
    ]
  }
];

const technologiesIWorkIn = 
[
  {
    title: "TECHNOLOGIES I WORK IN",
    contents: [
      "Javascript","NodeJs","Express Js","MongoDB",
      "React Js","TypeScript","NestJs","Angular2+",
      "MEAN Stack","MERN Stack","CSS","SCSS",
      "C","C++","C#","JAVA","MySQL","MSSQL",
      "SOLID","OOP","Git","Github"
    ]
  }
];

const toolsIKnow = 
[
  {
    title: "TOOLS I KNOW",
    contents: [
      "VSCode","Visual Studio","Figma","AdobeXd",
      "Canva","PostMan","Draw.io"
    ]
  }
];

return (
  <Fragment>
      <Dots background="#000" color="#00FFA5" customLoading={loading}/>
      <div className="about-page">
        {/* <GoBack/> */}
        <div className="hero-section-container">
          {aboutData && <HeroSection data={aboutData} />}
        </div>
        <div className="explore-section-container">
        <div className="life-hastag-content">
            {lifeHashTag && <AboutContent data={lifeHashTag} contenttype="tag"/>}
          </div>
          <div className="explore-row">
            {aboutMeData && <ContentRow data={aboutMeData} />}
          </div>
          <div className="technologies-content">
            {technologyData && <AboutContent data={technologyData} contenttype="tech"/>}
          </div>
          <div className="tools-content">
            {toolListData && <AboutContent data={toolListData} contenttype="tools"/>}
          </div>
          <div className="go-to-portfolio">
            <div className="container">
              <div className="row mt-5">
                <div className="col-md-4 col-lg-4"></div>
                <div className="col-md-4 col-lg-4">
                  <Link className="portfolio_link" to="/main/portfolio">
                    CHECK OUT MY WORKS<span>
                    <ArrowRight className="porfolio_right"/></span></Link>
                </div>
                <div className="col-md-4 col-lg-4"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </Fragment>
);
}

export default About;